import { selectFromRouteDto } from '../../models';
import RouteBreakdownSolutionQuery from './RouteBreakdownSolutionQuery';
import RouteBreakdownConstraintQuery from './RouteBreakdownConstraintQuery';

export default selectFromRouteDto()
  .isStarted
  // projectId is required to fetch the nextTimelineEvent
  .projectId
  .unpublishedChanges
  .nextTimelineEvent(timelineEvent => timelineEvent.routeTimelineId.visitId.eventType.originalArrivalTime.expectedArrivalTime)
  .routePerformanceEvent(event => event.routeTimelineId.visitId.eventType.originalArrivalTime.expectedArrivalTime)
  .hexColor
  .constraints(RouteBreakdownConstraintQuery)
  .activeRouteSolution(RouteBreakdownSolutionQuery)
  .toString();
